import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import QRCode from 'qrcode.react';
import React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';

import { qrcodeStyle } from './styles';

class QRCodeComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            qrCodeValue: this.props.qrCodeValue,
            size: this.props.size,
        }
    }
    componentDidMount() {
        // this.props.serviceBranchDispatch.getBranchForOwner({ serviceCode: '' });
    }
    componentWillReceiveProps = (nextProps) => {
        if(nextProps.qrCodeValue !== this.state.qrCodeValue) this.setState({qrCodeValue: nextProps.qrCodeValue})
        if(nextProps.size !== this.state.size) this.setState({size: nextProps.size})
    }
    render() { 
        const {qrCodeValue, size} = this.state;
        const {classes} = this.props
        return (
            <div className={classes.qrCode}>
                {qrCodeValue ?
                    <QRCode
                        id= 'qrcodeCavas'
                        value={qrCodeValue}
                        size={size}
                        fgColor='#000000'
                        bgColor='#ffffff'
                        level='L'
                        imageSettings = {{
                            src: 'https://static.zpao.com/favicon.png',
                            x: null,
                            y: null,
                            height: 24,
                            width: 24,
                            excavate: true,
                        }} 
                        // renderAs='svg'
                    />
                    : ''
                }
            </div>
        )
    }
}

QRCodeComponent.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};

const mapState = state => ({ 
});

const mapDispatch = dispatch => ({
    serviceBranchDispatch: dispatch.serviceBranch,
});

export default connect(mapState, mapDispatch)(translate('translations')(withStyles(qrcodeStyle, { withTheme: true })(QRCodeComponent)));